import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CLINIC } from "../lib/clinic";

export const FloatingActions = () => {
  return (
    <>
      {/* WhatsApp - all devices, right side */}
      <a
        href={CLINIC.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
        className="fixed bottom-7 right-7 z-40 w-13 h-13 px-4 py-4 rounded-full bg-brand-navyDark text-[#FAF9F7] border border-brand-gold/40 shadow-[0_18px_40px_-12px_rgba(11,27,52,0.5)] flex items-center justify-center transition-transform hover:scale-105"
      >
        <MessageCircle className="w-5 h-5" strokeWidth={1.5} />
      </a>

      {/* Call - mobile only, left side */}
      <a
        href={`tel:${CLINIC.phoneRaw}`}
        aria-label="Call Dr. Avril"
        data-testid="floating-call"
        className="fixed bottom-7 left-7 z-40 md:hidden w-13 h-13 px-4 py-4 rounded-full bg-white text-brand-navyDark border border-brand-navyDark/30 shadow-[0_18px_40px_-12px_rgba(11,27,52,0.3)] flex items-center justify-center transition-transform hover:scale-105"
      >
        <Phone className="w-5 h-5" strokeWidth={1.5} />
      </a>
    </>
  );
};
